import {createContext, useContext, useState, useMemo} from 'react';

export const LabContext = createContext<ILabContext>({
  lab: undefined,
  updateLabInfo: () => null,
  updateLocationInfo: () => null,
  updateOwnerInfo: () => null,
  updateLabType: () => null,
  updateActivityFiled: () => null,
  updateLabTests: () => null,
  resetForm: () => null,
  updateLab: () => null,
});

type TLabProviderProps = {
  children: React.ReactNode;
};

export const LabProvider = ({children}: TLabProviderProps) => {
  const [lab, SetLab] = useState<ILabAddInfo | undefined>();

  const updateLabInfo = (shopData: ILabUpdateInformation) => {
    if (shopData)
      SetLab(prev => ({
        ...prev,
        license: shopData.license,
        title: shopData.title,
        about: shopData.about,
        logo: shopData.logo,
        establishment_year: shopData?.establishment_year,
      }));
  };

  const updateLocationInfo = (labData: ILabUpdateLocation) => {
    if (labData) {
    }
    SetLab(prev => ({
      ...prev,
      city: labData?.city,
      state: labData?.state,
      location: labData?.location,
      activity_state: labData?.activity_state,
      activity_city: labData?.activity_city,
      from_hour: labData.from_hour,
      result_from_day: labData?.result_from_day,
      result_to_day: labData?.result_to_day,
      to_hour: labData?.to_hour,
    }));
  };

  const updateOwnerInfo = (labData: ILabUpdateOwner) => {
    if (labData)
      SetLab(prev => ({
        ...prev,
        owner_name: labData.owner_name,
        owner_age: labData?.owner_age,
        phone_number: labData?.phone_number,
        land_line: labData?.land_line,
        national_card: labData?.national_card,
        speciality: labData?.speciality,
      }));
  };

  const updateLabType = (shopType: ILabType) => {
    if (shopType)
      SetLab(prev => ({
        ...prev,
        store_type: shopType,
      }));
  };

  const updateActivityFiled = (activityFiles: ILabUpdateActivityFiled) => {
    if (activityFiles)
      SetLab(prev => ({
        ...prev,
        activity_field: activityFiles?.activity_field,
      }));
  };

  const updateLabTests = (selectedTests: ILabUpdateLabTests) => {
    if (selectedTests)
      SetLab(prev => ({
        ...prev,
        lab_tests: selectedTests?.tests?.map(x => x.guid).toString() || '',
      }));
  };
  const resetForm = () => {
    SetLab(undefined);
  };
  const updateLab = (shop: ILabAddInfo) => {
    SetLab(shop);
  };
  const value = useMemo(
    () => ({
      lab,
      updateLabInfo,
      updateLocationInfo,
      updateOwnerInfo,
      updateLabType,
      updateActivityFiled,
      updateLabTests,
      resetForm,
      updateLab,
    }),
    [lab],
  );
  return <LabContext.Provider value={value}>{children}</LabContext.Provider>;
};

export const useLab = () => {
  return useContext(LabContext);
};
